import { useMemo, useState } from 'react'
import { Trans } from 'react-i18next'

import { AvatarCell, AvatarSize, Button, ButtonVariant, Field, Label, Modal, SelectDropdown } from '@makyoapp/makyo-ui'

import { useGetOrgTeams } from '@/resolvers/org/query'
import { SaveButton } from '@/components/SaveButton'

interface TeamSelectionModalProps {
  isOpen: boolean
  onClose: () => void
  onChangeTeam: (teamId: string) => void
  isLoading: boolean
  teamId: string
}

function TeamSelectionModal({ isOpen, onClose, onChangeTeam, isLoading, teamId }: TeamSelectionModalProps) {
  // const queryClient = useQueryClient()
  // const { currentOrg } = useCurrentOrgContext()
  // const currentOrgId = currentOrg?.id

  const { data: teamsData } = useGetOrgTeams({
    search: '',
  })

  const teams = useMemo(() => teamsData || [], [teamsData])

  const [team, setTeam] = useState<string>('')

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!team) return
    onChangeTeam(team)
  }

  const handleClose = () => {
    setTeam('')
    onClose()
  }

  return (
    <Modal id='team-selection-modal' show={isOpen} onHide={handleClose}>
      <form
        id='team-selection-modal-form'
        onSubmit={(e) => {
          e.preventDefault()
          handleSubmit(e)
        }}
      >
        <Modal.Header onCloseClick={handleClose}>Select Team</Modal.Header>
        <Modal.Body className='modal-md'>
          <Field>
            <Label>
              <Trans>Team</Trans>
            </Label>
            <SelectDropdown
              id='org-detail-new-app-team'
              value={teams.find((ts) => ts.id === team) || teams.find((ts) => ts.id === teamId)}
              onChange={(opt) => {
                setTeam(opt.id)
              }}
              optionLabel={(opt) => opt.name}
              renderOption={(opt) => {
                return <AvatarCell size={AvatarSize.XS} {...opt} />
              }}
              options={teams}
            />
          </Field>
          <div className='flex w-full justify-between mt-2'>
            <Button type='button' variant={ButtonVariant.Outlined} onClick={handleClose}>
              Cancel
            </Button>
            <SaveButton isLoading={isLoading} type='submit' disabled={!teamId}>
              Save
            </SaveButton>
          </div>
        </Modal.Body>
      </form>
    </Modal>
  )
}

export default TeamSelectionModal
